export const INTERNAL_IDENTIFIER_VALIDATION_REGEX = /^[a-zA-Z0-9_-]+$/i;

export const EMAIL_VALIDATION_REGEX =
  /^[A-Z0-9.'_%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

// ISO-8601 full-date (calendar date, no time). Value stored by date custom fields.
export const ISO_DATE_VALIDATION_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const URL_VALIDATION_REGEX =
  // oxlint-disable-next-line eslint/no-useless-escape -- FIXME: pre-existing error: Unnecessary escape character '+'
  // oxlint-disable-next-line eslint/no-useless-escape -- FIXME: pre-existing error: Unnecessary escape character '+'
  /^(https?:\/\/)(www\.)?[a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/i;
